export class GasFlowPara {
    constructor({
        id= ``,
        prdDate= ``,
        recTime= ``,
        locName= ``,
        locId= ``,
        shiftName= ``,
        actualPower1= ``,
        openDegree1= ``,
        flow1= ``,
        actualPower2= ``,
        openDegree2= ``,
        flow2= ``,
        actualPower3= ``,
        openDegree3= ``,
        flow3= ``,
        actualPower4= ``,
        openDegree4= ``,
        flow4= ``,
        intake1= ``,
        intake2= ``,
        cabinetPosition= ``,
    }={}) {
        this.id = id;
        this.prdDate = prdDate;
        this.recTime = recTime;
        this.locName = locName;
        this.locId = locId;
        this.shiftName = shiftName;
        this.actualPower1 = actualPower1;
        this.openDegree1 = openDegree1;
        this.flow1 = flow1;
        this.actualPower2 = actualPower2;
        this.openDegree2 = openDegree2;
        this.flow2 = flow2;
        this.actualPower3 = actualPower3;
        this.openDegree3 = openDegree3;
        this.flow3 = flow3;
        this.actualPower4 = actualPower4;
        this.openDegree4 = openDegree4;
        this.flow4 = flow4;
        this.intake1 = intake1;
        this.intake2 = intake2;
        this.cabinetPosition = cabinetPosition;
    }
}

export function gridFields() {
    return Object.freeze([
      {
        key: 'prdDate',
        label: 'lbl.basic.date',
        sortable: true,
        form: {
          type: 'datepicker'
        }
      },
      {
        key: 'recTime',
        label: 'lbl.basic.datetime',
        sortable: true,
        form: {
          type: 'timepicker'
        }
      },
      {
        key: 'locName',
        label: 'lbl.fm.locationName',
        filterable: true,
        default: 'default',
        form: {
          type: 'dimSearch',
          url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
          config: {
            validate: "", // 参数检查，可以是正则表达式等
            bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
            bindProp: "locName", // 显示的属性的名称
            submitProp: "locName" // 提交的属性
          }
        }
      },
      {
        key: 'locId',
        label: 'lbl.formulaPlan.locationCode',
        notInTable: true,
        form: {
          type: 'dimSearch',
          url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
          config: {
            validate: "", // 参数检查，可以是正则表达式等
            bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
            bindProp: "id", // 显示的属性的名称
            submitProp: "id" // 提交的属性
          }
        }
      },
      {
            key: 'shiftName',
            label: 'lbl.shiftPlan.shiftName',
            sortable: true,
            default: 'default',
            form: {
              type: 'select',
              options: [
                {value:"default",text:"lbl.basic.select.one"},
                {value:"甲",text:"lbl.shift.A"},
                {value:"乙",text:"lbl.shift.B"},
                {value:"丙",text:"lbl.shift.C"}
              ]
            }
        },
        {
            key: 'actualPower1',
            label: 'lbl.gcm.actualPower1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'openDegree1',
            label: 'lbl.gcm.openDegree1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'flow1',
            label: 'lbl.gcm.flow1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'actualPower2',
            label: 'lbl.gcm.actualPower2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'openDegree2',
            label: 'lbl.gcm.openDegree2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'flow2',
            label: 'lbl.gcm.flow2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'actualPower3',
            label: 'lbl.gcm.actualPower3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'openDegree3',
            label: 'lbl.gcm.openDegree3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'flow3',
            label: 'lbl.gcm.flow3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'actualPower4',
            label: 'lbl.gcm.actualPower4',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'openDegree4',
            label: 'lbl.gcm.openDegree4',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'flow4',
            label: 'lbl.gcm.flow4',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'intake1',
            label: 'lbl.gcm.intake1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'intake2',
            label: 'lbl.gcm.intake2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cabinetPosition',
            label: 'lbl.gcm.cabinetPosition',
            sortable: true,
            form: {
              type: 'input'
            }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new GasFlowPara()).map(i => 'entity.' + i));

export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.shiftNameFilter',
    'filter.locNameFilter',
];

export const filter = {
    'startTimeFilter': "",
    'endTimeFilter': "",
    'shiftNameFilter':"default",
    'locNameFilter':"default",
};